$(function () {
	const tabs = $(".nav__tab");
	$(".nav__tab").on("click", function () {
		$(".active").removeClass("active");
		$(this).addClass("active");
		const index = tabs.index(this);
		$(".contents").removeClass("show").eq(index).addClass("show");
	});
});
